import { useEffect, createContext, useState } from 'react';
import { Routes, Route, Outlet, useLocation } from 'react-router-dom'
import { io } from 'socket.io-client';
import axios from 'axios'
import Main from './pages/frontpage/main';
import Login from './pages/login';
import DMain from './pages/dashboard/main';
import NewBook from './pages/dashboard/newBook';
import { Logout } from './pages/logout';
import { Navbar } from './components/navbar';
import Books from './pages/books/books';
import BookDetail from './pages/books/bookDetail';
import ConfirmBook from './pages/dashboard/confirmBook';
import Checkout from './pages/checkout/checkout';
import MyOrdersPage from './pages/dashboard/myOrders';
import Saldo from './pages/dashboard/saldo';
import SettingsPage from './pages/dashboard/settings';
import EditBook from './pages/dashboard/editBook';
import { Alert } from './components/dashboard/alert';
import Confirmation from './pages/confirmation/confirmation';
import HelpPage from './pages/help/main';
import Shipping from './pages/help/shipping';
import Conditions from './pages/help/conditions';
import { Footer } from './components/footer';
import Contact from './pages/contact/main';
import Inbox from './pages/dashboard/inbox';
import Order from './pages/dashboard/order';
import LoginModal from './components/login/loginModal';
import ProtectedRoutes from './ProtectedRoutes';
import ResetPassword from './pages/resetPassword';
import MyBooksPage from './pages/dashboard/myBooks';
import Verify from './pages/dashboard/verify';
import UploadImage from './pages/uploadImage/uploadImage';

export const UserContext = createContext()

function App() {

    axios.defaults.baseURL = "https://srv807290.hstgr.cloud/"
    //axios.defaults.baseURL = "http://localhost:5000"
    const [auth, setAuth] = useState(false)
    const [user, setUser] = useState()
    const [unread, setUnread] = useState(0)
    const [socket, setSocket] = useState(null)
    const [isLoading, setIsLoading] = useState(true)
    const [contentLoaded, setContentLoaded] = useState(false)
    const { pathname } = useLocation()
    const [myShips, setMyShips] = useState([])
    const [notifications, setNotifications] = useState([])
    const token = localStorage.getItem('token')
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
      window.scrollTo({top: 0, behavior: 'auto'})
    }, [pathname])

    useEffect(() => {
      async function checkAuth() {
        if (token) {
          await axios.get('/api/protected', {
            headers: {
              Authorization: `Bearer ${token}`
            },
          }).then(
            res => {
              setAuth(true)
              setUser(res.data.user)
            }
          ).catch(() => {
            setAuth(false)
          })
        } else {
          setAuth(false)
        }
        setIsLoading(false)
      }

      checkAuth()
    }, [])

    useEffect(() => {
      if (auth) {
        axios({
          method: 'post',
          url: '/api/myShipments',
          headers: {
            Authorization: `Bearer ${token}`
          }
        }).then(
          res => {
            setMyShips(res.data)
          }
        ).catch(() => {
        })
        
        axios({
          method: 'post',
          url: '/api/notifications',
          headers: {
            Authorization: `Bearer ${token}`
          }
        }).then(
          res => {
            setNotifications(res.data)
          }
        ).catch(() => {
        })
      }
    }, [auth])
    
    useEffect(() => {
      if (!socket) {
        const newSocket = io('wss://srv807290.hstgr.cloud', { transports: ['websocket'] });
        //const newSocket = io('http://192.168.1.16:5000', { transports: ['websocket'] });

        newSocket.on('connect', () => {
          console.log('Connected to server');
        });
        
        newSocket.on('new_notification', (data) => {
          setNotifications(prev => {
            const newList = [...prev]
            if (!newList.some(a => a.chatId === data.chatId)) {
              newList.push(data)
            } else {
              const notification = newList.find(a => a.chatId === data.chatId)
              notification.msg = data.msg
            }
            return newList
          })
        });

        setSocket(newSocket);
      }

      return () => {
        socket.off('new_notification')
        socket.disconnect();
      };
    }, []);

    useEffect(() => {
      if (socket && user && user._id) {
        socket.emit('join_conversations', user._id);
      }
    }, [user, socket]);

    if (isLoading) {
      return <div className={"w-full absolute h-full z-50 transition-[opacity] duration-500 ease-in-out bg-emerald-500"}></div>
    }

    return (
      <div className="page relative min-h-lvh flex flex-col justify-between">
        <UserContext.Provider value={{ user: user, setUser: setUser, auth: auth, setAuth: setAuth, contentLoaded: contentLoaded, setContentLoaded: setContentLoaded, notifications: notifications, setNotifications: setNotifications, socket: socket, showModal: showModal, setShowModal: setShowModal }}>
          <Navbar />
          {/*<div className="w-full fixed top-[104px] md:top-[106px] z-30 flex flex-col gap-2">
            {myShips.filter(a => a.status === 0).map((shipment) => {
              return <Alert shipment={shipment} />
            })}
          </div>*/}
          {pathname === '/login' ?
            ""
          :
            <LoginModal showModal={showModal} setShowModal={setShowModal} />}
          <Routes>
            <Route path='/' element={<Main />} />
            <Route path='/checkout' element={<Checkout />} />
            <Route path='/bøger'>
              <Route path='' element={<Books />} />
              <Route path='id=:bookId' element={<Books />} />
              <Route path=':dbId' element={<BookDetail />} /> 
            </Route>
            <Route path='/login' element={<Login />} />
            <Route path='/reset_password' element={<ResetPassword />} />
            <Route path='/logout' element={<Logout />} />
            <Route path='/sælgBog' element={<NewBook />} />
            <Route path='/uploadImage' element={<UploadImage />} />
            <Route path='confirm'>
              <Route path=':dbId' element={<ConfirmBook />} />
            </Route>
            <Route path='/indbakke' element={<Inbox />} />
            <Route path='/bekræftelse' element={<Confirmation />} />
            <Route path='/dashboard' element={<ProtectedRoutes />}>
              <Route path='' element={<DMain />} />
              <Route path='bøger' element={<MyBooksPage />} />
              <Route path='ordrer' element={<MyOrdersPage />} />
              <Route path='saldo' element={<Saldo />} />
              <Route path='profil' element={<SettingsPage />} />
              <Route path='editBook' element={<EditBook />} />
              <Route path='ordre' element={<Order />} />
            </Route>
            {/*<Route path='/hjælp' element={<Outlet />}>
              <Route path='' element={<HelpPage />} />
              <Route path='forsendelse' element={<Shipping />} />
              <Route path='betingelser' element={<Conditions />} />
            </Route>*/}
            {/*<Route path='kontakt' element={<Contact />} />*/}
          </Routes>
          {pathname === '/login' ?
            ""
          :
            <Footer />}
        </UserContext.Provider>
      </div>
    )
}

export default App